<template>
  <div class="row">
    <VeeForm
      class="col"
      v-slot="{ handleSubmit, meta }"
      :validation-schema="schema"
      as="div"
    >
      <div class="alert alert-danger d-none" id="alertError" role="alert"></div>
      <form
        @submit="handleSubmit($event, onSubmit)"
        class="row"
        id="generalityForm"
        ref="generalityForm"
      >
        <div class="col">
          <!-- //* Parcours -->
          <div class="row mb-2 mt-5">
            <div class="col mt-1">
              <h2 class="section-title text-uppercase">Parcours</h2>
            </div>
          </div>

          <div class="row">
            <!-- //? Type de participation -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="participationType" class="form-label required"
                >Je veux participer en tant que :</label
              >
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="participationType"
                  id="participationType1"
                  value="Apprenant"
                  v-model="participationType"
                />
                <label class="form-check-label" for="participationType1">
                  Apprenant
                </label>
              </div>
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="participationType"
                  id="participationType2"
                  value="Formateur"
                  v-model="participationType"
                />
                <label class="form-check-label" for="participationType2">
                  Formateur
                </label>
              </div>
              <ErrorMessage
                name="participationType"
                as="div"
                class="invalid-feedback d-block"
              />
            </div>
            <!-- //? Recherche d'emploi -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="jobSearching" class="form-label required"
                >Êtes-vous en recherche d'emploi ?</label
              >
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="jobSearching"
                  id="jobSearching1"
                  value="Oui"
                  v-model="jobSearching"
                />
                <label class="form-check-label" for="jobSearching1">
                  Oui
                </label>
              </div>
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="jobSearching"
                  id="jobSearching2"
                  value="Non"
                  v-model="jobSearching"
                />
                <label class="form-check-label" for="jobSearching2">
                  Non
                </label>
              </div>
              <ErrorMessage
                name="jobSearching"
                as="div"
                class="invalid-feedback d-block"
              />
            </div>
            <!-- //? Emploi à quitter -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="wantToQuitJob" class="form-label required"
                >Avez-vous un emploi que vous souhaitez quitter ?</label
              >
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="wantToQuitJob"
                  id="wantToQuitJob1"
                  value="Oui"
                  v-model="wantToQuitJob"
                />
                <label class="form-check-label" for="wantToQuitJob1">
                  Oui
                </label>
              </div>
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="wantToQuitJob"
                  id="wantToQuitJob2"
                  value="Non"
                  v-model="wantToQuitJob"
                />
                <label class="form-check-label" for="wantToQuitJob2">
                  Non
                </label>
              </div>
              <ErrorMessage
                name="wantToQuitJob"
                as="div"
                class="invalid-feedback d-block"
              />
            </div>
          </div>

          <!-- //? Matrice niveaux - Apprenant -->
          <div class="row mb-4" v-if="participationType == 'Apprenant'">
            <div class="col">
              <div class="card">
                <div class="card-body">
                  <p class="mb-1">
                    Si vous voulez être apprenant, veuillez indiquer votre niveau
                    pour chaque module :
                  </p>
                  <ul class="mb-3">
                    <li><b>Débutant</b> : Connaissances de base</li>
                    <li><b>Intermédiaire</b> : Bonne maîtrise</li>
                    <li><b>Avancé</b> : Expertise confirmée</li>
                  </ul>
                  <div class="table-responsive">
                    <table class="table align-middle module-table">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th
                            scope="col"
                            class="text-center"
                            v-for="level in levels"
                            :key="level"
                          >
                            {{ level }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="module in modules" :key="module.key">
                          <td>
                            {{ module.label }}
                            <ErrorMessage
                              :name="'apprenant_' + module.key"
                              as="div"
                              class="text-danger small"
                            />
                          </td>
                          <td
                            class="text-center"
                            v-for="level in levels"
                            :key="level"
                          >
                            <Field
                              class="form-check-input module-radio"
                              type="radio"
                              :name="'apprenant_' + module.key"
                              :value="level"
                              v-model="apprenantLevels[module.key]"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- //? Matrice niveaux - Formateur -->
          <div class="row mb-4" v-if="participationType == 'Formateur'">
            <div class="col">
              <div class="card">
                <div class="card-body">
                  <p class="mb-1">
                    Si vous voulez être formateur, veuillez indiquer votre niveau
                    pour chaque module :
                  </p>
                  <ul class="mb-3">
                    <li>
                      <b>Débutant</b> : Connaissances de base, peu ou pas
                      d'expérience en formation
                    </li>
                    <li>
                      <b>Intermédiaire</b> : Bonne maîtrise, capable de former
                      avec supervision
                    </li>
                    <li>
                      <b>Avancé</b> : Expertise confirmée, capable de concevoir
                      et dispenser des formations de haut niveau
                    </li>
                  </ul>
                  <div class="table-responsive">
                    <table class="table align-middle module-table">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th
                            scope="col"
                            class="text-center"
                            v-for="level in levels"
                            :key="level"
                          >
                            {{ level }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="module in modules" :key="module.key">
                          <td>
                            {{ module.label }}
                            <ErrorMessage
                              :name="'formateur_' + module.key"
                              as="div"
                              class="text-danger small"
                            />
                          </td>
                          <td
                            class="text-center"
                            v-for="level in levels"
                            :key="level"
                          >
                            <Field
                              class="form-check-input module-radio"
                              type="radio"
                              :name="'formateur_' + module.key"
                              :value="level"
                              v-model="formateurLevels[module.key]"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- //? Expérience : intitulé -->
            <div class="mb-3 col-12">
              <label class="form-label">
                Nombre d'années d'expérience à un poste en lien avec une des
                compétences évoquées. Préciser la compétence et le nombre
                d'années :
              </label>
            </div>
            <!-- //? Sous-champs indentés -->
            <div class="col-12">
              <div class="row experience-subfields">
                <!-- //? Compétence -->
                <div class="mb-4 col-lg-6 col-md-6 col-sm-12 col-12">
                  <label for="experienceSkill" class="form-label required"
                    >Compétence</label
                  >
                  <Field
                    name="experienceSkill"
                    type="text"
                    label="compétence"
                    v-slot="{ field, errorMessage }"
                    v-model="experienceSkill"
                  >
                    <input
                      id="experienceSkill"
                      v-bind="field"
                      placeholder="Saisissez la compétence"
                      class="form-control"
                      :class="{ 'is-invalid': errorMessage }"
                    />
                  </Field>
                  <ErrorMessage
                    name="experienceSkill"
                    as="div"
                    class="invalid-feedback"
                  />
                </div>
                <!-- //? Nombre d'années -->
                <div class="mb-4 col-lg-6 col-md-6 col-sm-12 col-12">
                  <label for="experienceYears" class="form-label required"
                    >Nombre d'années</label
                  >
                  <Field
                    name="experienceYears"
                    type="number"
                    label="nombre d'années"
                    v-slot="{ field, errorMessage }"
                    v-model="experienceYears"
                  >
                    <input
                      id="experienceYears"
                      v-bind="field"
                      type="number"
                      min="0"
                      step="1"
                      placeholder="Saisissez le nombre d'années"
                      class="form-control"
                      :class="{ 'is-invalid': errorMessage }"
                    />
                  </Field>
                  <ErrorMessage
                    name="experienceYears"
                    as="div"
                    class="invalid-feedback"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- //? Disponibilité -->
            <div class="mb-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <label class="form-label required">Seriez-vous disponible ?</label>
              <div
                class="form-check"
                v-for="option in availabilityOptions"
                :key="'availability-' + option"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="option"
                  :id="'availability-' + option"
                  v-model="availability"
                />
                <label class="form-check-label" :for="'availability-' + option">
                  {{ option }}
                </label>
              </div>
              <div class="text-danger small mt-1" v-if="availabilityError">
                Veuillez sélectionner au moins une option.
              </div>
            </div>
          </div>

          <div class="mt-2">
            <button
              class="btn btn-lg btn-primary"
              @click="$emit('to-previous')"
              type="button"
            >
              Précédent
            </button>
            <button
              class="btn btn-lg btn-primary ms-2"
              id="submit-button"
              type="submit"
            >
              Suivant
            </button>
          </div>

          <div class="row mb-4">
            <span class="text-danger d-none" id="form-invalid-error"
              ><i v-if="!meta.valid">
                Une ou plusieurs erreurs sont présentes dans le formulaire.</i
              ></span
            >
            <div class="mt-3 fst-italic">
              <span class="text-muted">
                <label class="required"></label> Obligatoire
              </span>
            </div>
          </div>
        </div>
      </form>
    </VeeForm>
  </div>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import { defineRule } from "vee-validate";
import { required, integer, min_value } from "@vee-validate/rules";

defineRule("required", required);
defineRule("integer", integer);
defineRule("min_value", min_value);
defineRule("required_if_apprenant", (value, [role]) => {
  if (role === "Apprenant" && (value === undefined || value === null || value === "")) {
    return "Ce champ est obligatoire";
  }
  return true;
});
defineRule("required_if_formateur", (value, [role]) => {
  if (role === "Formateur" && (value === undefined || value === null || value === "")) {
    return "Ce champ est obligatoire";
  }
  return true;
});

import { setLocale } from "@vee-validate/i18n";
import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import fr from "@vee-validate/i18n/dist/locale/fr.json";
configure({
  generateMessage: localize({
    fr,
  }),
});
setLocale("fr");

const MODULES = [
  { key: "agile", label: "Développement en mode Agile" },
  { key: "sdlc", label: "Software Development Life Cycle (SDLC)" },
  { key: "cicd", label: "Continuous Integration / Continuous Delivery (CI/CD)" },
  { key: "clickup", label: "Project Management avec ClickUp" },
  { key: "ia", label: "Développeur IA" },
  { key: "fullstack", label: "Développeur Fullstack (React & Node.js)" },
  { key: "mobile", label: "Développeur Mobile" },
  { key: "devsecops", label: "DevSecOps Architect" },
];

const LEVELS = ["Débutant", "Intermédiaire", "Avancé"];

const AVAILABILITY_OPTIONS = [
  "Tout le mois d'octobre 2026",
  "Tout le mois de novembre 2026",
  "Tout le mois de décembre 2026",
];

const AVAILABILITY_SEPARATOR = "||";

export default {
  name: "EeiaCareer",
  inject: [
    "ToastSuccess",
    "ToastError",
    "currentYearUrl",
    "AlertWarning",
    "AlertSuccess",
    "AlertError",
  ],
  components: {
    // Rename form to avoid confusion with native `form`
    VeeForm,
    Field,
    ErrorMessage,
  },
  props: {
    previousData: Object,
    step: Number,
    nativeCountry: String,
  },
  mounted() {
    document
      .getElementById("submit-button")
      .addEventListener("click", function () {
        document
          .getElementById("form-invalid-error")
          .classList.remove("d-none");
      });
  },
  data() {
    const schema = {
      participationType: "required",
      jobSearching: "required",
      wantToQuitJob: "required",
      experienceSkill: "required",
      experienceYears: "required|integer|min_value:0",
    };

    MODULES.forEach((module) => {
      schema["apprenant_" + module.key] =
        "required_if_apprenant:@participationType";
      schema["formateur_" + module.key] =
        "required_if_formateur:@participationType";
    });

    const apprenantLevels = {};
    const formateurLevels = {};
    MODULES.forEach((module) => {
      apprenantLevels[module.key] =
        this.previousData["apprenant_" + module.key] || "";
      formateurLevels[module.key] =
        this.previousData["formateur_" + module.key] || "";
    });

    return {
      schema,
      modules: MODULES,
      levels: LEVELS,
      availabilityOptions: AVAILABILITY_OPTIONS,
      participationType: this.previousData.participationType,
      jobSearching: this.previousData.jobSearching,
      wantToQuitJob: this.previousData.wantToQuitJob,
      experienceSkill: this.previousData.experienceSkill,
      experienceYears: this.previousData.experienceYears,
      apprenantLevels,
      formateurLevels,
      availabilityError: false,
      availability: this.previousData.availability
        ? this.previousData.availability.split(AVAILABILITY_SEPARATOR)
        : [],
    };
  },
  watch: {
    availability(newValue) {
      if (newValue && newValue.length > 0) {
        this.availabilityError = false;
      }
    },
  },
  methods: {
    onSubmit(values, actions) {
      if (!this.availability || this.availability.length === 0) {
        this.availabilityError = true;
        return;
      }

      this.beforeSendPromise(values, this).then((formData) => {
        this.$http
          .post("new-candidacies", formData)

          .then(() => {
            this.$emit("career-sent", this.participationType);
            this.$emit("to-next");
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.ToastError.fire({
                title: "Veuillez bien remplir le formulaire et réessayez.",
              });

              let errors = error.response.data.errors;
              for (const key in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, key)) {
                  const element = errors[key];
                  actions.setFieldError(key, element);
                }
              }
            } else if (error.response.status == 403) {
              this.AlertError.fire({
                icon: "error",
                title: "Non autorisé",
                html: "Vous ne pouvez plus modifier votre candidature.",
              });
            } else {
              this.ToastError.fire({
                title: "Une erreur s'est produite, veuillez réessayer.",
              });
            }
          });
      });
    },
    beforeSendPromise(values, $this) {
      return new Promise(function (resolve) {
        let formData = new FormData();
        formData.append("step", 2);

        formData.append("participationType", $this.participationType);
        formData.append("jobSearching", $this.jobSearching);
        formData.append("wantToQuitJob", $this.wantToQuitJob);

        MODULES.forEach((module) => {
          formData.append(
            "apprenant_" + module.key,
            $this.apprenantLevels[module.key] || ""
          );
          formData.append(
            "formateur_" + module.key,
            $this.formateurLevels[module.key] || ""
          );
        });

        formData.append("experienceSkill", $this.experienceSkill || "");
        formData.append("experienceYears", $this.experienceYears || "");
        formData.append(
          "availability",
          $this.availability.join(AVAILABILITY_SEPARATOR)
        );

        resolve(formData);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 768px) {
  .form-control,
  .form-select {
    line-height: 2;
  }
}

.section-title {
  border-bottom: 3px solid #3490dc;
}

.module-table tbody tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}

.module-radio {
  width: 1.3em;
  height: 1.3em;
  float: none;
  margin-left: 0;
}

.experience-subfields {
  margin-left: 1.5rem;
  padding-left: 1rem;
}
</style>
